
import App from '../app';
import * as D from '~/data-utils';
import $ from 'jquery';
import Constants from './Constants';
import HistoryAPI from '../history';

import {
  getAllFloors,
  getFloorById,
  getOfficeTowerById,
  getOfficeTowersWithTenants,
  getStores,
  __
} from '../data-utils';


var storelist = {};
let history;

function init(context) {
  var stores = getStores();
  var categories = getCategories();
  var floors = getAllFloors();
  var officeTowers = getOfficeTowersWithTenants();
  var alphas = Constants.ALPHAS;
  var alphabets = getAlphabets(alphas);
  var langs = D.langs();
  var lang = D.lang();
  var translations = App.getTranslations(langs);

  const { feature } = context.imdSettings;

  //saved storelist
  storelist = getSavedStorelist();

  if($.isEmptyObject(storelist)){
    //default values
    storelist = {
      title: '',
      stores: stores,
      categories: categories,
      floors: floors,
      officeTowers: officeTowers,
      officeTower: '',
      alphabets: alphabets || alphas,
      view: feature.stores.view,
      sortby: 'name',
      letter: '',
      lastletter: '',
      lastposition: 0,
      scrollposition: 0,
      category: '',
      floor: '',
      store: '',
      iconsvg: context.resources.get('ic_store'),
      icontitle: translations[lang]['common.storeDirectory'],
      translations: translations,
      currentLang: lang,
      feature
    };
  }

  history = new HistoryAPI('#list', {
    categories,
    floors,
    iconsvg: storelist.iconsvg,
    officeTowers,
    stores,
    translations
  });

  return storelist;
}

function getStorelist(){
  return storelist;
}

function getSavedStorelist() {
  var currentStorelist = App.getStoredData('currentStorelist', 'all');
  return currentStorelist;
}

function getCategories(){
  var lang = D.lang();
  var scdata = App.getStoredData('scdata', lang);
  var categories = scdata.shoppingCenterData.fieldsOfBusiness;
  return categories;
}

function getAlphabets(alphas){
  var storelist = getStores();
  var alphabets = [];
  $.map(storelist, function(store){
    if(store.name){
      var letter = store.name.slice(0,1).toUpperCase();
      if(alphas.indexOf(letter)== -1){
        letter = '#';
      }
      if(alphabets.indexOf(letter) == -1) {
        if(letter!='#'){
          alphabets.push(letter);
        }else{
          alphabets.unshift(letter);
        }
      }
    }
  });
  return alphabets;
}

function getOfficeTowerName (id) {
  const { description } = getOfficeTowerById(id);
  return description;
}

function getFloorName (id) {
  const { description, name } = getFloorById(id);
  return description || `${__('common.floor')} ${name}`;
}

function getCategoryName(id){
  var name = $.map(storelist.categories, function(cat){
    if(cat.id == id){
      return cat.description;
    }
  });
  return name;
}
function getStoreNameFirstLetter(id){

  var letter = '';
  $.each(storelist.stores, function(i, store){
    if(store.id == id){
      letter = store.name.slice(0,1).toUpperCase();
    }
  });

  if(Constants.ALPHAS.indexOf(letter)== -1){
    letter = 'other';
  }

  return letter;
}

function getNextLetter(letter, direction){

  var nextLetter = letter;
  letter = (letter === 'other')? '#' : letter;

  var index = storelist.alphabets.indexOf(letter);
  index += (direction === 'next')? 1 : -1;

  if(index >=0 && index <= storelist.alphabets.length - 2) {
    nextLetter = storelist.alphabets[index];
  }

  nextLetter = (nextLetter === '#')? 'other' : nextLetter;

  return nextLetter;

}
function setTitle(name){
  storelist.title = name;
}
function setView(view, currentletter){
  storelist.view = view;
  storelist.lastletter = currentletter;
  storelist.lastposition = storelist.scrollposition;
  storelist.scrollposition = 0;
}
function setSortBy(sortby){
  storelist.sortby = sortby;
  storelist.letter = '';
  storelist.lastposition = storelist.scrollposition;
  storelist.scrollposition = 0;
  storelist.floor = '';
  storelist.category = '';
  storelist.title = '';
  storelist.officeTower = '';
}
function setAlphabet(newLetter, currentLetter){
  storelist.lastletter = currentLetter;
  storelist.letter = newLetter;
}
function setPosition(position){
  storelist.scrollposition = position;
}
function setCategory(id){
  storelist.category = id;
  storelist.officeTower = '';
  storelist.floor = '';
  storelist.letter = '';
}
function setFloor(id){
  storelist.floor = id;
  storelist.officeTower = '';
  storelist.category = '';
  storelist.letter = '';
}
function setOfficeTower(id){
  storelist.officeTower = id;
  storelist.floor = '';
  storelist.category = '';
  storelist.letter = '';
}
function clearLetter(){
  storelist.letter = '';
}

function updateLastPosition (position) {
  storelist.lastposition = position;
  App.saveLocally(storelist, 'currentStorelist', 'all');
}

function updateState(){
  history.updateState(storelist);
}
function saveState(){
  history.saveState(storelist);
}
async function goBack(){
  const [historyState, state] = await history.goBackAsync();
  /* state is always hydrated with staticData so it won't ever be null */
  if (historyState){
    storelist = state;
    return true;
  } else {
    window.location.href = '#start';
    return false;
  }
}

function goTo(hash){
  window.location.href=hash;
}

export default {
  init,
  getStorelist,
  getStores,
  getCategories,
  getOfficeTowerName,
  getFloorName,
  getCategoryName,
  getAlphabets,
  getStoreNameFirstLetter,
  getNextLetter,
  setTitle,
  setAlphabet,
  setPosition,
  setView,
  setSortBy,
  setCategory,
  setFloor,
  setOfficeTower,
  clearLetter,
  updateState,
  updateLastPosition,
  saveState,
  goBack,
  goTo
};
